<template>
  <div class="summary-page">
    <h1>Summary & Statistics</h1>
    <p>Some charts and stats will go here.</p>
  </div>
</template>

<script setup>
// Placeholder for now
</script>

<style scoped>
.summary-page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: white;
  color: #333;
  text-align: center;
}
</style>
